import { ErrorBaseData } from '.'

export const organizationErrors: Record<string, ErrorBaseData> = {
  OrganizationNotFoundException: {
    message: 'Organização não encontrada',
    description: 'Não foi possível encontrar a organização. Verifique as informações e tente novamente',
  },
  OrganizationAlreadyExistsException: {
    message: 'Organização já existe',
    description: 'Esta organização já existe. Verifique as informações e tente novamente',
  },
}
